import script from "./device.vue?vue&type=script&setup=true&lang=js"
export * from "./device.vue?vue&type=script&setup=true&lang=js"

import "./device.vue?vue&type=style&index=0&id=82f43e08&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f43e08"]])

export default __exports__